import htmlSplit from '@/pages/htmlSplit/split'

export default [
  {
    path: '/htmlSplit/split',
    name: 'htmlSplit',
    component: htmlSplit
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/htmlSplit.js